import NotificationModal from "src/components/NotificationModal";
import SpendCreditsModal from "src/components/SpendCreditsModal";

const modals = {
    notification: NotificationModal,
    spendCredits: SpendCreditsModal,
};

export default modals;
